import { UPDATE_ROUTE_DATA, FILTER_COLLAPSE, UPDATE_SRP_BUS_DATA, UPDATE_GO_SAFE_BANNER, UPDATE_ROUTE_ID, STORE_LEAVE_INTENT_DATA } from './constants'
import { IUPDATE_ROUTE_DATA, IFILTER_COLLAPSE, IUPDATE_SRP_BUS_DATA } from './validations';

export function updateRouteData(
  actionData: IUPDATE_ROUTE_DATA['actionData'],
): IUPDATE_ROUTE_DATA {
  return {
    type: UPDATE_ROUTE_DATA,
    actionData,
  };
}

export function filterCollapse(actionData: IFILTER_COLLAPSE['actionData']): IFILTER_COLLAPSE {
  return {
    type: FILTER_COLLAPSE,
    actionData,
  };
}

export function updateSRPBusData(
  actionData: IUPDATE_SRP_BUS_DATA['actionData'],
): IUPDATE_SRP_BUS_DATA {
  return {
    type: UPDATE_SRP_BUS_DATA,
    actionData,
  };
}

export function updateGoSafeBanner(actionData) {
  return {
    type: UPDATE_GO_SAFE_BANNER,
    actionData
  }
}

export function updateRouteId(actionData: string) {
  return {
    type: UPDATE_ROUTE_ID,
    actionData
  }
}

export function storeLeaveIntentData(actionData) {
  return {
    type: STORE_LEAVE_INTENT_DATA,
    actionData
  }
}
